/* VENDORED — DO NOT EDIT BY HAND. See scripts/vendor-manifest.mjs.
   source:  andavo-dev libs/client/shared/shared/util/api/src/errors.ts
   commit:  e4d5051bce
   repoint: this file maps to @andavo/* at merge into andavo-dev.
 */
/** Thrown for non-ok HTTP responses. Carries the status code for retry decisions. */
export class ApiError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

/**
 * Thrown when an HTTP 429 (Too Many Requests) response is received.
 * Carries the server-specified retry delay so callers can back off appropriately.
 */
export class RateLimitError extends ApiError {
  readonly retryAfterMs: number;

  constructor(message: string, retryAfterSeconds: number) {
    super(message, 429);
    this.name = 'RateLimitError';
    this.retryAfterMs = retryAfterSeconds * 1000;
  }
}

/**
 * Thrown when the access token cannot be resolved after retries.
 *
 * This prevents unauthenticated requests from reaching the backend, which
 * would return 401 and trigger a full logout via clearCredentials. By
 * short-circuiting before the fetch, TanStack Query treats this as a
 * normal query error — the user sees an error state in the UI but stays
 * logged in and can retry once Auth0 recovers.
 */
export class AuthTokenUnavailableError extends Error {
  constructor() {
    super(
      'Unable to retrieve access token. Please check your connection and try again.',
    );
    this.name = 'AuthTokenUnavailableError';
  }
}
